/* src/app/components/account/manage-user/manage-user-edit/manage-user-edit.component.scss */
.row {
  padding-bottom: 15px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.list {
  height: 200px;
  overflow: auto;
  border: 1px solid #949494;
  border-radius: 4px;
}
.link {
  font-size: 12px;
  margin-right: 5px;
}
.circle-icon {
  line-height: 30px !important;
  text-align: center;
  width: 30px !important;
  height: 30px !important;
  color: #3949ab;
  background-color: #C5CAE9;
  padding: 5px;
  border-radius: 50%;
  vertical-align: middle;
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
:host-context(.dark-theme) .list {
  border: 1px solid #656565;
}
/*# sourceMappingURL=manage-user-edit.component.css.map */
